import { TRACKING_COMPONENTS } from '../../shared/enum/tracking.enum';
import {
  CMSButton,
  CMSImage,
  CMSInput,
  CMSItem,
  CMSPackageSection,
} from '../../shared/model/cms-model';
import { getProperty } from './../../shared/utils/getProperty';
import { CMS_RESPONSE } from './../mock/cms.mock';

export class LandingModel {
  title: string;

  subtitle: string;

  offer_title: string;
  offer_title_1: string;
  offer_description_1: string;
  offer_icon_1: string;

  offer_title_2: string;
  offer_description_2: string;
  offer_icon_2: string;

  offer_title_3: string;
  offer_description_3: string;
  offer_icon_3: string;

  offer_card: CMSItem;
  offer_card_image: CMSImage;
  offer_card_link: CMSItem;

  productCard_title: string;
  productCard: CMSItem;

  step_by_step: CMSItem;
  step_by_step_footer: CMSItem;
  step_by_step_image: CMSImage;

  boxes_1_title: string;
  boxes_1_subtitle: string;
  boxes_1_description: string;

  boxes_2_title: string;
  boxes_2_subtitle: string;

  documentCPF: CMSInput;
  continueButton: CMSButton;
  topBanner_Desktop: string;
  topBanner_Mobile: string;
  footer: any;
  legal: any;
  boxes_imagem_1: any;
  boxes_imagem_2: any;
  boxes_imagem_3: any;

  //Sections

  bennefits_section: CMSPackageSection;
  bennefits_price_section: CMSItem;

  requestCardDiscraimer: CMSItem;
  cookie_alert_text: CMSItem;
  cookie_alert_button_text: CMSItem;

  constructor(model?: any) {
    const titleComplete: string = getProperty(model, 'title');
    const subtitleComplete: string = getProperty(model, 'subtitle');

    this.title = titleComplete;

    this.subtitle = subtitleComplete;

    this.documentCPF = new CMSInput(
      getProperty(
        model,
        'components._onboardingcmc_componente_documento_cpf',
        CMS_RESPONSE.components._onboardingcmc_componente_documento_cpf
      )
    );
    this.documentCPF.eventLabel = TRACKING_COMPONENTS.CPF_INPUT;
    this.continueButton = new CMSButton(
      getProperty(
        model,
        'components._onboardingcmc_componente_open_account',
        CMS_RESPONSE.components._onboardingcmc_componente_open_account
      )
    );
    this.continueButton.eventLabel = TRACKING_COMPONENTS.CONTINUE_BUTTON;

    this.offer_title = getProperty(
      model,
      'components._onboardingcmc_componente_offer._onboardingpf_componente_item_title',
      CMS_RESPONSE.components._onboardingcmc_componente_offer
        ._onboardingpf_componente_item_title
    );
    this.offer_title_1 = getProperty(
      model,
      'components._onboardingcmc_componente_offer_1._onboardingpf_componente_item_title',
      CMS_RESPONSE.components._onboardingcmc_componente_offer_1
        ._onboardingpf_componente_item_title
    );
    this.offer_description_1 = getProperty(
      model,
      'components._onboardingcmc_componente_offer_1._onboardingpf_componente_item_description',
      CMS_RESPONSE.components._onboardingcmc_componente_offer_1
        ._onboardingpf_componente_item_description
    );
    this.offer_icon_1 = getProperty(
      model,
      'components._onboardingcmc_componente_offer_1._onboardingpf_componente_item_icon',
      CMS_RESPONSE.components._onboardingcmc_componente_offer_1
        ._onboardingpf_componente_item_icon
    );

    this.offer_title_2 = getProperty(
      model,
      'components._onboardingcmc_componente_offer_2._onboardingpf_componente_item_title',
      CMS_RESPONSE.components._onboardingcmc_componente_offer_2
        ._onboardingpf_componente_item_title
    );
    this.offer_description_2 = getProperty(
      model,
      'components._onboardingcmc_componente_offer_2._onboardingpf_componente_item_description',
      CMS_RESPONSE.components._onboardingcmc_componente_offer_2
        ._onboardingpf_componente_item_description
    );
    this.offer_icon_2 = getProperty(
      model,
      'components._onboardingcmc_componente_offer_2._onboardingpf_componente_item_icon',
      CMS_RESPONSE.components._onboardingcmc_componente_offer_2
        ._onboardingpf_componente_item_icon
    );

    this.topBanner_Desktop = getProperty(
      model,
      'components._onboardingcmc_componente_proposta_banner.campo-banner.PadraoImagemProposta_bloblink_',
      CMS_RESPONSE.components._onboardingcmc_componente_proposta_banner[
        'campo-banner'
      ].PadraoImagemProposta_bloblink_
    );
    this.topBanner_Mobile = getProperty(
      model,
      'components._onboardingcmc_componente_proposta_banner.campo-banner.MediaImagemProposta_bloblink_',
      CMS_RESPONSE.components._onboardingcmc_componente_proposta_banner[
        'campo-banner'
      ].MediaImagemProposta_bloblink_
    );

    this.step_by_step = new CMSItem(
      getProperty(
        model,
        'components._onboardingcmc_componentes_step_by_step',
        CMS_RESPONSE.components._onboardingcmc_componentes_step_by_step
      )
    );
    this.step_by_step_image = new CMSImage(
      getProperty(
        model,
        'components._onboardingcmc_componentes_step_by_step_image.campo-banner',
        CMS_RESPONSE.components._onboardingcmc_componentes_step_by_step_image[
          'campo-banner'
        ]
      )
    );
    this.step_by_step_footer = new CMSItem(
      getProperty(
        model,
        'components._onboardingcmc_componentes_step_by_step_footer',
        CMS_RESPONSE.components._onboardingcmc_componentes_step_by_step_footer
      )
    );

    this.boxes_1_title = getProperty(
      model,
      'components._onboardingcmc_componente_boxes._onboardingpf_componente_item_title',
      CMS_RESPONSE.components._onboardingcmc_componente_boxes
        ._onboardingpf_componente_item_title
    );
    this.boxes_1_subtitle = getProperty(
      model,
      'components._onboardingcmc_componente_boxes._onboardingpf_componente_item_subtitle',
      CMS_RESPONSE.components._onboardingcmc_componente_boxes
        ._onboardingpf_componente_item_subtitle
    );
    this.boxes_1_description = getProperty(
      model,
      'components._onboardingcmc_componente_boxes._onboardingpf_componente_item_description',
      CMS_RESPONSE.components._onboardingcmc_componente_boxes
        ._onboardingpf_componente_item_description
    );
    this.boxes_2_title = getProperty(
      model,
      'components._onboardingcmc_componente_boxes_2._onboardingpf_componente_item_description',
      CMS_RESPONSE.components._onboardingcmc_componente_boxes_2
        ._onboardingpf_componente_item_description
    );
    this.boxes_2_subtitle = getProperty(
      model,
      'components._onboardingcmc_componente_boxes_2._onboardingpf_componente_item_subtitle',
      CMS_RESPONSE.components._onboardingcmc_componente_boxes_2
        ._onboardingpf_componente_item_subtitle
    );

    this.offer_card_image = new CMSImage(
      getProperty(
        model,
        'components._onboardingpf_componente_card_image.campo-banner',
        CMS_RESPONSE.components._onboardingpf_componente_card_image[
          'campo-banner'
        ]
      )
    );
    this.offer_card = new CMSItem(
      getProperty(
        model,
        'components._onboardingcmc_componente_card',
        CMS_RESPONSE.components._onboardingcmc_componente_card
      )
    );
    this.offer_card_link = new CMSItem(
      getProperty(
        model,
        'components._onboardingcmc_componente_card_link',
        CMS_RESPONSE.components._onboardingcmc_componente_card_link
      )
    );

    this.productCard_title = getProperty(
      model,
      'components._onboardingcmc_component_productCard_cartao_flow_sx._onboardingpf_componente_productCard_title',
      CMS_RESPONSE.components
        ._onboardingcmc_component_productCard_cartao_flow_sx
        ._onboardingpf_componente_productCard_title
    );
    this.productCard = new CMSItem(
      getProperty(
        model,
        'components._onboardingcmc_component_productCard_cartao_flow_sx',
        CMS_RESPONSE.components
          ._onboardingcmc_component_productCard_cartao_flow_sx
      )
    );

    this.boxes_imagem_1 = getProperty(
      model,
      'components._onboardingcmc_componente_img_boxes.campo-banner.MediaImagemProposta_bloblink_',
      CMS_RESPONSE.components._onboardingcmc_componente_img_boxes[
        'campo-banner'
      ].MediaImagemProposta_bloblink_
    );
    this.boxes_imagem_2 = getProperty(
      model,
      'components._onboardingcmc_componente_img_boxes.campo-banner.PadraoImagemProposta_bloblink_',
      CMS_RESPONSE.components._onboardingcmc_componente_img_boxes[
        'campo-banner'
      ].PadraoImagemProposta_bloblink_
    );
    this.boxes_imagem_3 = getProperty(
      model,
      'components._onboardingcmc_componente_img_boxes.campo-banner.GrandeImagemProposta_bloblink_',
      CMS_RESPONSE.components._onboardingcmc_componente_img_boxes[
        'campo-banner'
      ].GrandeImagemProposta_bloblink_
    );

    this.bennefits_section = new CMSPackageSection(
      getProperty(
        model,
        'components._onboardingpf_componente_benefits',
        CMS_RESPONSE.components._onboardingpf_componente_benefits
      )
    );
    this.bennefits_price_section = new CMSItem(
      getProperty(
        model,
        'components._onboardingcmc_componente_bennefits_price_section',
        CMS_RESPONSE.components
          ._onboardingcmc_componente_bennefits_price_section
      )
    );

    this.requestCardDiscraimer = new CMSItem(
      getProperty(
        model,
        'components._onboardingcmc_componente_request_your_card_disclaimer',
        CMS_RESPONSE.components
          ._onboardingcmc_componente_request_your_card_disclaimer
      )
    );

    this.cookie_alert_text = new CMSItem(
      getProperty(
        model,
        'components._onboardingcmc_componente_alert_cookie',
        CMS_RESPONSE.components._onboardingcmc_componente_alert_cookie
      )
    );
    this.cookie_alert_button_text = new CMSItem(
      getProperty(
        model,
        'components._onboardingcmc_componente_alert_button',
        CMS_RESPONSE.components._onboardingcmc_componente_alert_button
      )
    );
  }

  format(stringName: string, initial: number, length: number) {
    if (stringName) {
      return stringName.substr(initial, length);
    }
  }
}
